<template>
  <div class="admin-wrap">
    <div class="admin-sidebar">
      <div class="links-wrap">
        <ul>
          <li>Reported:</li>
          <li
            v-for="(link, index) in links"
            :key="index"
            :class="link.meta.indented ? 'indented' : ''"
          >
            <router-link v-if="link.name" :to="{ name: link.name }"
              >{{ link.meta.value }}
            </router-link>
            <span v-else>{{ link.meta.value }}:</span>
          </li>
        </ul>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <router-view class="admin-page"></router-view>
    </transition>
    <transition name="arrow">
      <span class="material-icons" @click="scrollTop" v-if="showArrow"
        >keyboard_arrow_down</span
      >
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      showArrow: false,
    };
  },
  computed: {
    ...mapState(["permissions"]),
    links() {
      let routes = [];
      this.$router.options.routes.forEach((route) => {
        if (route.path == "/admin") routes = route.children;
      });
      return routes.filter((path) =>
        path.meta.permissions
          ? this.checkPermissions(path.meta.permissions)
          : true
      );
    },
  },
  created() {
    window.addEventListener("scroll", this.arrowListener);
  },
  destroyed() {
    window.removeEventListener("scroll", this.arrowListener);
  },
  methods: {
    scrollTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    arrowListener() {
      if (window.scrollY !== 0) {
        this.showArrow = true;
      } else {
        this.showArrow = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
a:active,
a:focus {
  outline: none;
}
.admin-wrap {
  display: flex;
  flex-wrap: nowrap;
  background-color: #F4F5F7;
  min-height: calc(100vh - var(--nav-height));
}
.admin-sidebar {
  min-width: 20em;
  max-width: 20%;
  padding: 20px 10px 20px 35px;
  box-sizing: border-box;
  background: #343434;
}
.links-wrap {
  position: sticky;
  top: 85px;
  max-height: calc(95vh - var(--nav-height));
  overflow-y: auto;
  user-select: none;
}
ul {
  list-style: none;
  padding: 0;
  color: white;
}
li {
  text-transform: uppercase;
  margin: 8px 0;
}
a {
  color: #fff;
}
.admin-page {
  flex-grow: 1;
  box-sizing: border-box;
}
.indent {
  display: block;
  margin-left: 10%;
  font-size: 1em;
}
.router-link-active {
  color: var(--button-color-blue);
}
.indented {
  margin-left: 10%;
}
.material-icons {
  transform: rotate(180deg);
  font-size: 30px;
  position: fixed;
  bottom: 50px;
  right: 50px;
  background-color: white;
  border-radius: 50%;
  padding: 10px;
  cursor: pointer;
  user-select: none;
}
// ** TRANSITIONS **
.arrow-enter-active,
.arrow-leave-active {
  transition: opacity 0.5s;
}
.arrow-enter,
.arrow-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}
</style>